var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.80005 4.5002c0-.99412.80589-1.8 1.8-1.8h7.19995c.9942 0 1.8.80588 1.8 1.8v9c0 .9941.8059 1.8 1.8 1.8h-10.79995c-.99411 0-1.8-.8059-1.8-1.8zm2.7.9h5.4v3.6h-5.4zm5.4 5.4h-5.4v1.8h5.4z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.5 6.3002h.9c.9942 0 1.8.80588 1.8 1.8v4.95c0 .7456-.6044 1.35-1.35 1.35-.7455 0-1.35-.6044-1.35-1.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.acb2aedaf295cfa403c0887bc951f4af.svg";
export { ForwardRef as ReactComponent };